<template>
<div class="page page_yuekan">
    <van-tabs v-model="active" swipe-threshold="6" @change="changeTabFun">
        <van-tab title="全部" :name="-1"></van-tab>
        <van-tab v-for="item in typeList" :title="item.title" :name="item.id" :key="item.id"></van-tab>
    </van-tabs>
    <div class="shaixuan clearfix">
        <div class="f-l shaixuan_item quanbu" @click="clickTotal">全部</div>
        <div class="f-l shaixuan_item city" @click="shaiXuanFun(0)">选择城市</div>
        <div class="f-l shaixuan_item time" @click="shaiXuanFun(1)">开始时间</div>
    </div>
    <!-- 城市筛选 -->
    <div class="xiala" v-if="show_dropdown">
        <ul v-if="type==0">
            <!-- <li class="xiala_item">全部</li> -->
            <li class="xiala_item" v-for="item in areaList" :key="'0'+item.id" @click="selectCity(item.id)">{{item.areaname}}</li>
        </ul>
        <!-- 时间筛选 -->
        <ul v-if="type==1">
            <li class="xiala_item" v-for="(item,index) in timeList" :key="index" @click="selectTime(item)">{{item}}</li>
        </ul>
    </div>
    <!-- 热门推荐 -->
    <div class="tuijian flexstart" v-if="tuijian.length > 0">
        <div class="tuijian_t">热门推荐</div>
        <van-swipe :loop="false">
            <van-swipe-item v-for="(item,index) in tuijian" :key="'0'+index" class=“item>
                <ul class="list">
                    <li class="item" v-for="item in item" :key="item.id" @click="goDetail(item.id)">
                        <img :src="imageUrl+item.thumb" alt="" class="tu">
                    </li>
                </ul>
            </van-swipe-item>
        </van-swipe>
    </div>
    <!-- 约看产品 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
        <div class="product">
            <div class="pro_item clearfix" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
                <div class="pro_item_l f-l">
                    <img :src="imageUrl+item.thumb" alt="" class="tu">
                </div>
                <div class="pro_item_r f-l">
                    <div class="pro_item_r_t clearfix">
                        <div class="title f-l slh">{{item.title}}</div>
                        <div class="price f-r"><span class="tag_cash">¥</span>{{item.price}}</div>
                    </div>
                    <div class="pro_item_r_b">
                        <div class="info clearfix">
                            <div class="info_l f-l">位置：</div>
                            <div class="info_r f-l slh_s">
                                <span v-if="item.provice">{{item.provice.areaname}}</span>
                                <span v-if="item.city">{{ '>' + item.city.areaname}}</span>
                                <span v-if="item.area">{{'>' + item.area.areaname}}</span>
                            </div>
                        </div>
                        <div class="info clearfix">
                            <div class="info_l f-l">类型：</div>
                            <div class="info_r f-l slh_s" v-if="item.type">{{item.type.title}}</div>
                        </div>
                        <div class="info clearfix">
                            <div class="info_l f-l">简介：</div>
                            <div class="info_r slh f-l">{{item.describe}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </van-list>
    <!-- 全局遮罩 -->
    <!-- <van-overlay :show="show_dropdown" @click="show_dropdown = false" /> -->
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "home-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token:'',
            active: -1,
            type: 0, // 城市0、时间1
            show_dropdown: false, // 遮罩层状态
            areaList: [], // 可选择城市列表
            typeList: [], // 活动类型
            tuijian: [], // 热门推荐
            list: [], // 约看列表
            areaid: null, // 城市ID int
			time: '今天', // 时间 string
			timeList: ['今天','三天内','一周内','一个月内'] , // 时间
            loading: false, // 当前页数据加载完
            finished: false, // 全部数据加载完
            pages: {
                page: 1,
                size: 10
			},
            goNext: false,
			shareConfig: null // 分享的相关配置
        };
    },
    created: function () {
		this.pages.page = 1
        // this.getData()
        var that = this
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '约看',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
			var memberParams = {
				data: {
					notCallLogin: 1,
				},
			};
			this.$bridge.callhandler(
				"sdjy://member/memberInfo",
				memberParams,
				(data) => {
					if (data.code == 200) {
						this.token = data.result.token;
						this.getData()
					} else {
						this.token = "";
					}
				}
			);
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '约·看',
                        detail: '特色非遗体验，等你来打卡~\n这些非遗特色体验向你发出邀请~',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'yuekan.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
			this.token = this.$store.getters.token;
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
			this.getShareData()
        }
    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.list = []
			this.pages.page = 1
			this.getData()
		}
	},
    methods: {
        // 获取数据
        getData() {
            var params = {
				token: this.token,
				time: this.time,
                page: this.pages.page,
                size: this.pages.size
            }
            if (this.active != -1) {
                params.typeid = this.active
            }
            if (this.areaid) {
                params.areaid = this.areaid
            }
            this.$api.live.index(params).then(res => {
                if (res.code == 200) {
					// 活动分类
					this.typeList = res.result.type
					// 约看列表
					var list = res.result.list
                    this.loading = false
                    this.list.push.apply(this.list,list);

					// 可选择城市列表
                    var areaArr = res.result.area 
                    // areaArr.unshift({
                    //     id: -1,
                    //     areaname: '全部'
                    // })
					this.areaList = areaArr
					// 推荐 要3个一组
                    var arr = res.result.pos 
                    var result = []
                    for (var i = 0; i < arr.length; i += 3) {
                        result.push(arr.slice(i, i + 3))
                    }
                    console.log('推荐3个一组')
                    console.log(result)
					this.tuijian = result
					// 数据加载完
                    if (list.length == 0) { 
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
                console.log('finished', this.finished)
            })
            // 当前页加载完
            this.pages.page++
        },
        // 约看详情
        goDetail(id) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/yuekan/detail?id=' + id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/yuekan/detail',
                    query: {
                        id: id
                    }
                })
            }
        },
        // 筛选
        shaiXuanFun(type) {
            this.type = type
            this.show_dropdown = !this.show_dropdown
        },
        // 
        changeTabFun(e) {
            this.pages.page = 1;
            this.loading = true, // 当前页数据加载完
            this.finished = false, // 全部数据加载完
            this.show_dropdown = false;
			this.list = [];
            this.getData()
        },
        // 选择城市
        selectCity(id) {
            // if (id != -1) {
            //     this.areaid = id
			// }
			this.areaid = id
            this.loading = true, // 当前页数据加载完
            this.finished = false, // 全部数据加载完
            this.show_dropdown = false
			this.pages.page = 1
			this.list = []
            this.getData()
		},
		// 选择时间
		selectTime(time){
			this.time = time
            this.loading = true, // 当前页数据加载完
            this.finished = false, // 全部数据加载完
			this.show_dropdown = false
			this.list = []
            this.pages.page = 1
            this.getData()
		},
		// 点击全部
		clickTotal(){
			this.list = []
			this.pages.page = 1
			this.time = "今天"
			this.areaid = null
            this.loading = true, // 当前页数据加载完
            this.finished = false, // 全部数据加载完
			this.show_dropdown = false;
			this.getData()
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: '约·看', // 分享标题
					desc: '特色非遗体验，等你来打卡~\n这些非遗特色体验向你发出邀请~', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.shareImgPath + 'yuekan.jpg', // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    body {
        min-height: 100vh;
    }
</style>
